const Success = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 15C4.1402 15 1 11.8598 1 8C1 4.1402 4.1402 1 8 1C11.8598 1 15 4.1402 15 8C15 11.8598 11.8598 15 8 15Z"
      fill="#72C472"
    />
    <path
      d="M6.599 11.5004C6.4198 11.5004 6.2406 11.4318 6.1041 11.2953L4.0041 9.19527C3.7304 8.92157 3.7304 8.47917 4.0041 8.20547C4.2778 7.93177 4.7202 7.93177 4.9939 8.20547L6.599 9.81057L11.0041 5.40547C11.2778 5.13177 11.7202 5.13177 11.9939 5.40547C12.2676 5.67917 12.2676 6.12157 11.9939 6.39527L7.0939 11.2953C6.9574 11.4318 6.7782 11.5004 6.599 11.5004Z"
      fill="white"
    />
  </svg>
)

export default Success
